export default __webpack_public_path__ + "static/media/Conviction1_2.fdd02f65.png";